import { render, staticRenderFns } from "./content-row-agegroup.vue?vue&type=template&id=1bdb04f8&scoped=true"
import script from "./content-row-agegroup.vue?vue&type=script&lang=js"
export * from "./content-row-agegroup.vue?vue&type=script&lang=js"
import style0 from "./content-row-agegroup.vue?vue&type=style&index=0&id=1bdb04f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb04f8",
  null
  
)

export default component.exports